	import mapview 		 from '@/components/mapview.vue';
	import default_snack from '@/components/info/js/alert_modal.js'
	import management  	 from '@/components/info/management_incidents' 
	import cam 						from "@/components/cam_test.vue"
	import zone							from '@/components/zones/zones.vue'
	// import Image from "@/components/info/ImageInfo.vue"
import { point } from 'leaflet';

	// console.log("default_list_actions ", default_list_actions )
	
	export default {
		name  : 'modal_alert',		
		props :[
			'info_to_component',
			'info_to_category',			
			'type', // type modal / snack / info
			'is_soundd', 
			'number_alerts',
			'ref_to_component',
			'show_devices',
		],
		components:{			
			mapview,		
			management,	
			cam,
			zone,
			// Image,
		}, // components
		data  : (vm) => ({
			dialog 			: false,
			width 			: '500',
			setting_img 	: {
				height  : 235,				
			}, 
			show_color 		: 'dark',
			show_modal 		: true,			
			headers_alert 	: [
				{
					type 	: 'info_icon',
					enable 	: true,
					text 	: '', // date
					key  	: 'date',
					color 	: 'white', 
					icon 	: 'mdi-calendar'
				},
				{
					type 	: 'info_icon_tag',
					enable 	: true,
					text 	: '',//tag
					key  	: 'tag',
					color 	: 'primary', // info 
					icon 	: 'mdi-label' // format-list-bulleted // crosshairs //  tag // marker-check // focus-field / horizontal // image-filter-center-focus / weak
				},
				{
					type 	: 'btn',
					enable 	: true,					
					btns 	: [
						{
							text 	: 'minimize',
							key 	: 'minimize',
							action 	: 'minimize_modal', // show
							color 	: 'secondary',
							color1 	: 'cyan',
							color2  : 'dark', 		
							icon 	: 'mdi-minus-box',
							tooltip : 'min_alert',
							enable  : true,
						},
						{														
							text 	: 'close',
							key 	: 'close',
							action 	: 'close_modal',
							color 	: 'error', 		
							color1  : 'white',
							color2  : 'white',
							icon 	: 'mdi-close',
							tooltip : 'close',							
							enable  : true,
						}
					]
				}

			], // headers_alert
			info : {
				
				contentt : {

					images   : [ 
						{ 
							img : vm.$EXT + '/img/no_img_found.png'
						} 
					],
					device 	 : 'host1',
					date  	 : vm.$momentz(new Date()),
					tag 	 : 'gun',
				},
				management : {}

			}, // content info to show			
			info_head   :  {
				date  	 : vm.$momentz(new Date()),
				tag 	 : 'gun',
			},
			searchs 	: {
				trained : "",
			},
			info_fields : [
				// {
				// 	text 	: 'img_full',
				// 	key 	: 'img_full',
				// 	col 	: 12,
				// 	cols 	: []
				// },
			], // info_fields
			info_btn : { 
				minimize : false,
				close 	 : false, 
			},
			timeout_alert   		: null,
			timeout_alert_close 	: 0,
			cancel_timeout_alert 	: false,
			timeout_alert_out 		: null,
			timeout_alert_stop 		: null,
			sound_play 				: null,
			default_category : [
				{
					name  : 'gun',
					isPopup : true,
					isSound : true,					
				},
				{
					name  : 'hand up',
					isPopup : true,
					isSound : true,					
				},
			],
			is_snack 		: false,
			snack_modal 	: { ...default_snack },
			alert_sound  : 'alert', // alert_success
			sound_play1  : null,
			bounding_box : null,
			draw 		 : { 
				rois			: [],
				// contexts 		: [],
				current_width 	: 200,
				current_height 	: 300,
			}, 
			list_videos 	 : [],
			show_video 		 : false,
			slider  		 : 0,
			settings_default : {
				order_col : {
					content1  : 0, // 
					content   : 1, // default
					locations : 2,
					videos    : 3,

				},
				width_col : {
					content 	: 12,
					content1 	: 12,
					locations   : 12,
					videos 		: 12,
				},
			},
			num_cols 	 	: 12,
			modal_ctr  		:{
				cols 	: {
					management 	: "6",
					// contentt1  	: "6",
					// contentt  	: "6",

				},
				orders 	: {
					contentt1  : "first",
					management : "last",
				}
			},
			draw_setting 	: { line_width : 3, },
			
			show  		 	: {
				management 			: true,
				name_report 	 	: false,
				records 			: false,

			},			
			list_show 		: [],
			list_no_show    : ["bbox", "no_bbox", "locations", "videos", "content_video_location"], // 
			ID_notification : "aler_modal",
			info_management : null,
			locationss 		: null,
			disableds  		: {
				to_train : false,
			},
			info_selections : {
				contentt  : [],
				contentt1 : []
			},
			loadings 	  : {
				contentt1 : false,
			},			
			zones 		  : null, 
			zoneSelected  : null,
			selectedDeviceId: '',
      		nearbyDevices: [],
			devices:[],
			streamings:[],
			isRequiredSelectionFace: false,
		}), // data

		created(){
			const info_get    =  this.$Helper.get_local('streaming_paramaters');
			this.$Format.update_list("ml", this.$ml);
	        if (info_get) {          
	        	let vm 			  = this;
	          	this.draw_setting = info_get; 
				this.line_width   = vm.draw_setting && vm.draw_setting.parameters && vm.draw_setting.parameters.line_width ? parseInt(vm.draw_setting.parameters.line_width) : 2 ;
        		this.draw_colors  = vm.draw_setting && vm.draw_setting.list && vm.draw_setting.list.length > 0 ? vm.draw_setting.list : null;
	        }
	        this.ID_notification += this.ref_to_component;
	        // this.info.management = {};

			// this.$nextTick(()=>{
				// this.show.management		= true;	
				// this.render_cols("management"); 
			// })
	        
		}, // created

		watch : {
			info_to_component: function(val){
				
				if (val) {
					this.info 		= {
						contentt : {
							images : [/*img*/],
						},
						management : true,
					};
					this.snack_modal.info = {
						image  	: '/img/no_img_found.png',
						options : true,
						list    : {
							tag  		: '',
							device  	: '',
							probability : '',
							date 		: ''
						},
					}
					this.$nextTick(()=>{
						this.render_info(val);
					});
				}
			}, // info to component

			dialog: function(val){
				if (!val && !this.snack_modal.is_minimizen) {
					// console.log("Clear info modal alert *************************")
					this.render_close();
					
				}
			}, // dialog


		}, // watch	

		methods : {

			actions(act, item, opt){
				// console.log(`act : ${act} \n opt : ${opt}`, "\n item :", item)
				if ( act == 'cancel_timeout') {

					this.show_color = 'dark';
					
					if (this.timeout_alert_stop) {
						clearInterval(this.timeout_alert_stop);
						this.timeout_alert_stop = null;
					}
					if (this.timeout_alert) {						
						clearTimeout(this.timeout_alert);
						this.timeout_alert 		= null;
					}

				}else if ( act == 'minimize_modal') {
					
					this.is_snack = !this.is_snack;
					this.$emit('render_type',{
						type  : 'type',
						value : this.is_snack  ? 'snack' : 'alert',
					});
					// console.log("minimize ",  this.is_snack, this.snack_modal.is_minimizen)

					this.draw_bbox(true);
					this.dialog   = !this.dialog;
					if (!this.is_snack) {
						this.render_cols();
						this.snack_modal.active 		= false;
						clearInterval(this.timeout_alert_stop);						
						this.show_color = 'dark';

					}else{
						this.snack_modal.is_minimizen 	= true;
						const timer = setTimeout(()=>{
							// console.log("minimizen **** ", this.snack_modal.is_minimizen);
							this.snack_modal.is_minimizen 	= false;
							this.render_close();
							clearTimeout(timer);
						},20)
					}

				}else if ( act == 'close_modal'){
					this.dialog = false;

				}else if ( act == 'cancel_alert'){

					const timer_cancel = setTimeout(()=>{
						this.$emit('close', false);
						clearTimeout(timer_cancel);
					}, 1000);
				}else if( act == 'ignore'){
					// this.actions_to_report(act, item);					
					this.dialog = false;
				}else if(act == "confirm_trained"){
					
				}else if(act == "trained"){
					this.trained();
				}else if(act == "changes_select"){
					
					if (opt.show_face) {						
							// item.url_thumbnail = this.$EXT + '/img/no_img_found.png';
						if (this.info_selections && this.info_selections.trained) {
							this.info_selections.date_at = this.info_selections.trained.date_at;
						}else{
							this.info_selections.date_at = "";	
							this.info_selections.trained = "";					
						}
					}

				}else if (act == "show_in_btn") {
					if (item) {
						if (item.show_in && item.show_in.valid && item.show_in.valid.length > 0) {					
							if (this.$store.getters["auth/permission"]("face","can_add", "face")) {

								if (this.info_selections) {
									for (let it of item.show_in.valid){
										
										if (this.info_selections[it]) {
											return true
										}
									}
								}
							}else{
								return false;
							}
						}
					}
					return false
				}
			}, // actions

			calculateDistance(point1, point2) {
				const [x1, y1, x2, y2] = [...point1, ...point2].map(Number);
				return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
			},
			findNearbyDevices() {
				const targetDevice = this.devices.find(d => d.deviceId === this.selectedDeviceId);
				if (!targetDevice || !targetDevice.points) {
					// console.log('Please select a valid device.',this.selectedDeviceId,targetDevice);
					return;
				}

				const distances = this.devices
					.filter(d =>  d.points)
					.map(otherDevice => {
					const totalDistance = otherDevice.points.reduce((acc, point, index) => {
						return acc + this.calculateDistance(point, targetDevice.points[index] || [0, 0]);
					}, 0);

					return {
						...otherDevice,
						totalDistance,
					};
					})
					.sort((a, b) => a.totalDistance - b.totalDistance);

				this.nearbyDevices = distances;
			},
			
			render_cols(content){				
				// console.log("==================== show render cols :  ", content, this.list_show)
				
				if (!this.list_show.includes(content) && content && !this.list_no_show.includes(content) ) {			
				
					// this.list_show.push(content);
				}

				if (this.list_show) {
					let len 	= this.list_show.length;
					let expand 	= 75; // 35
					// console.log("******************************* LENT : ", content, len)
					if (len == 1) {
						this.width 		= 550 + (expand * len); // bounding / cont
						this.num_cols 	= 12;

					}else
					if (len == 2) {
						this.num_cols 	= 6;
						this.width 		= 620 + (expand * len); // no bbox / cont

					}else
					if (len == 3) {
						this.num_cols 	= 4;
						this.width 		= 680 + (expand * len); // is locations / cont

					}else
					if (len > 3) {
						this.num_cols 	= 3;
						this.width 		= 820 + (expand * len); // is locations / cont

					}/*else
					if (len == 4) {
						this.num_cols = 4;
					}*/
					this.modal_ctr.cols.management = this.num_cols;

					// console.log("Check len ++++++++++++++++++++ : ", len , this.list_show)
					/*if (content == 'bbox') {

					}else
					if (content == 'no_bbox'){

					}else
					if (['videos', 'locations' ].includes(content)) {
					}else
					if (content == "management") {

					}*/
					// console.log("CHECK COLS *************************************+  ", this.num_cols,  this.width, content)
				}
			}, // render cols

			render_listed(list, field){
				// console.log("LIST ", list)
				if (list && this[list]) {
					return this[list];
				}else if(list && list.length > 0){
					return list;
				}else if(list && typeof list == "object" &&  typeof list.then === 'function' && field && field.list_filter){
					list.then(res=> {
						// console.log("res ", res)
						if (res && res.length > 0) {
							if (field) {
								field.list_filter = res;
							}
							return res;
						}else{
							return []
						}
					})
				}				
				return [];
			}, // render listed

			render_info(item){
				// info to show
				// console.log('render_info', this.type)
				if (item) {
					let bounding  	 = false;
					let is_locations = false;
					let get_videos   = true;
					let check_del 	 = ['videos', 'tag', 'date', 'bbox', 'analytic', 'table'];
					if (item.content && item.content.bbox) {
						bounding = true;
						// delete item.content.bbox;
					}

					/*if (item.analytic) {
						// delete item.analytic;
					}
					if (item.table) {
						// delete item.table;

					}*/
					if (["smart_event", "alarms"].includes(item.analytic)) {
						if (!this.list_show.includes('management')) {
							this.list_show.push('management');						
						}
						this.show.management = true;
					}else{
						this.show.management = false;
						let idx = this.list_show.findIndex( x => x == 'management');
						if (idx >= 0) {
							this.list_show.splice(idx, 1);
						}

					}

					let { content , content1, content2, videos, locations, zone } 	= item;
					this.info_management 										= item;
					this.info.contentt = { ...content };
					if(zone && zone.points){
						this.devices= JSON.parse(zone.points)
						console.log(JSON.parse(zone.points),"ZONE")
					}
					
					this.selectedDeviceId = this.info_to_component.deviceId
					this.findNearbyDevices();
					let vm = this
					if(vm.info_to_component && vm.info_to_component.devices){
						this.streamings = this.nearbyDevices.map(itemA => {
							// Encuentra un elemento en el array B que tenga el mismo deviceId que el elemento actual de A
							let matchingItemB = vm.info_to_component.devices.find(itemB => itemB.deviceId === itemA.deviceId);
							
							// Si se encuentra un elemento coincidente, fusiona los objetos
							if (matchingItemB && itemA.totalDistance < 2 ) {
								return { ...itemA, ...matchingItemB };
							}
						
							// Si no hay coincidencia, solo devuelve el elemento de A (o puedes elegir omitirlo)
							return itemA;
						});
					}
					

					
					let cont = 1;
					this.list_show.push('content');

					if (content1) {
						cont ++;
						this.list_show.push('content1')
						this.info.contentt1 =  content1 ;
						/*if (["face_detected"].includes(item.analytic) && item.original_source && item.original_source.tracker_id && this.info.contentt1 && this.info.contentt1.images) {
							console.log("Add images")
					
						}*/
					}
					if (content2) {
						cont ++;
						this.list_show.push('content2')

						this.info.contentt2 = { ...content2 };	
					}
					if (videos && videos.length > 0) {
						cont++;
						// this.info.video_map['videos'] = 
						this.info.cont_video_map = videos;
						this.list_videos  = videos;
						this.show_video   = true;
						get_videos 		  = false;
						this.list_show.push('content_video_location');
						// console.log("CHECK VIDEOS 1 ")

					}
					if (locations && locations.length > 0) {
						
						cont ++;
						is_locations 		 	 = true;
						this.info.cont_video_map = true;
						this.locationss = locations;
						if (!this.list_show.includes("content_video_location")) {
							this.list_show.push('content_video_location');
						}

						// this.render_cols('content3');
						
							
					}

					
					if (zone && ["smart_event", "alarms"].includes(item.analytic)) {
						this.zones = true;
						this.zoneSelected = {...zone} ;
						cont++;
						this.info.cont_zone = true;
						if(!this.list_show.includes("content_zone")) {
							this.list_show.push('content_zone');						
						}

					}else{
						if(this.list_show.includes("content_zone")) {
							this.zones = false;
							const idx = this.list_show.findIndex(x => x == "content_zone");
							if(idx >= 0){
								this.list_show.splice(idx,1);
							}
						}
					}

					

					// face /api/v1/face/:id/"

					// if (cont > 1) {
						// cont 			= cont == 2 ? 6 : cont == 3 ? 5 : cont == 4 ? 4 : 5;
						this.render_cols();//cont; 
					// }
					if (this.info.contentt) {

						for (let it in this.info.contentt){
							if (check_del.includes(it)) {
							// console.log("Modal del ", it);
								delete this.info.contentt[it];
							}
						}
					}

					// console.log("Modal : ", item, this.info); 
					if (item.content) {
						if (item.content.images && item.content.images.length > 0) {
							/*if (!item.content.images[0].img.includes('http')) {
								item.content.images[0].img = this.$URL + '/' + item.content.images[0].img;
							}*/
							this.snack_modal.info.image 	= item.content.images[0].img; // this.info.

						}else{
							this.snack_modal.info.image 	= this.$EXT + '/img/no_img_found.png';//this.$Helper.check_img('/img/no_img_found.png', this.$URL);
							// console.warn("Images not found for mini modal");
						}
						this.snack_modal.info.list.tag 			= item.content.tag;
						this.snack_modal.info.list.device 		= item.content.device//this.info.device;
						this.snack_modal.info.list.probability 	= item.content.probability;
						this.snack_modal.info.list.date 		= item.content.date;

						if (item.head) {
							this.snack_modal.info.list.tag 		= item.head.tag;	
							this.info_head  					= item.head;	

						}else{
							this.info_head = {
								tag  		: item.content.tag,
								date 		: item.content.date,
								prediction 	: item.content.prediction,
							}
							// delete this.info.content.tag;
							// delete this.info.content.date;
						}
					}
					
					// console.log("bounding", bounding);
					
					if (bounding) {
						// this.render_cols("bbox");
						try{
							if (['modal', 'alert', 'snack'].includes(this.type)) {

								this.draw_bbox(true);
							}
						}catch(er){
							console.warn("Error load bbox : ", er);
						}
					}else{
						// this.render_cols("no_bbox");
					}
					// if (is_locations) {
					// 	this.render_cols("locations");
					// }
					if (get_videos && item.content && item.content.date && item.deviceId) { // && item.createdAt
						// let video = item.videos;
						if (this.type == 'alert') {
							this.$nextTick(() => {
								if(this.dialog){
									this.get_videoss(item.content.date, item.deviceId); // item.createdAt
								}
							})
						}else if (this.type == 'modal') {

							this.get_videoss(item.content.date, item.deviceId); // item.createdAt
						}
						// delete item.videos;
					}
				}				
					
				// type modal
				if (this.type) {
					if (this.type == 'modal') {

						this.dialog = true;			
						
						if (this.headers_alert && this.headers_alert.length > 0 && this.headers_alert[2] && this.headers_alert[2].btns && this.headers_alert[2].btns.length > 0) {

							this.headers_alert[2].btns[0].enable = false;
						}
						if (item.alert) {
							delete item.alert;
						}

						// testing
						// this.alert_sound = 'success';
						// this.render_sound(true);

						// test snack
						// this.snack_modal.active  			= true;
						// this.snack_modal.color 				= 'dark';	
						// this.snack_modal.time  				= 10  * 1000;

						// this.render_colors(10, '#3F1313FF');

					}else if(this.type == 'alert' || this.type == 'snack'){

						if(this.type == 'snack'){
							this.is_snack = true;
						}else{
							this.is_snack = false;							
						}	

						if (item.alert) {
							let Alert = item.alert							
							this.render_category(this.info_head, Alert);
							delete item.alert;
						}

					}

				}
			}, // render info

			render_close(){
				
				const img = this.info.contentt.images; 
				this.actions('cancel_timeout');
				this.$emit('close', false);
				this.show_video = false;
				//

				this.info_selections = {
					contentt  : [],
					contentt1 : []
				};
				
				this.disableds.to_train 		= false;
				this.searchs.trained 			= "";

				// this.show.management  		= true;
				// this.info.reports 			= false;		
				this.list_show  			= ['management'];			

				this.width 	  				= 500;
				// this.num_cols 				= 12;

				if (this.type == 'modal') {
					if (this.headers_alert && this.headers_alert.length > 0 && this.headers_alert[2] && this.headers_alert[2].btns && this.headers_alert[2].btns.length > 0) {
						this.headers_alert[2].btns[0].enable = true;
					}
				}
				// if (this.draw) {
					/*let draws = this.draw,
						vm 	  = this;*/
					// if (draws.rois && draws.rois.length > 0) {
						// console.log("clear rois close alert modal ");
						// vm.draw.rois.forEach( function(ar_roi, idx_roi){
							// ar_roi.context_roi.clearRect(0, 0, ar_roi.current_width, ar_roi.current_height);
							/*if (ar_roi.roi) {								
								ar_roi.roi.width  = ar_roi.current_width - 100;
								ar_roi.roi.height = ar_roi.current_height - 100 ;
							}*/

						// })
					
						/*this.draw = { 
							rois			: [],
							// contexts 		: [],
							current_width 	: 200,
							current_height 	: 300,
						}; */
					// }


				// }

			}, // render close
	         


			redirect_img(val){				
				window.open(this.$Helper.check_img(val, this.$URL),'_blank');
			}, // redirect img

			render_sound(play = true, obj){
				/*if (this.sound_play && this.sound_play1) {	
					if (this.alert_sound == 'alert_success') {
						this.sound_play.play();
						this.sound_play.muted = false;
					}else {
						this.sound_play1.play();
						this.sound_play1.muted = false;
					}

				}else{*/
				if (play) {

					this.$nextTick( () =>{
						if (this.alert_sound) { // == 'alert'
							// console.log("PLAY SOUND ", this.alert_sound, obj);
							this.$Sounds.play(this.alert_sound);
							/*let audio = new Audio(this.alert_sound + '.mp3');
							audio.play();*/
						/*	this.sound_play 		= this.$refs.audio_play;
							this.sound_play.muted 	= false;
							this.sound_play.play();			
						}else{			
							let audio = new Audio('/sounds/' + this.alert_sound + '.mp3');
							audio.play();
							this.sound_play1 = audio;*/
							/*this.sound_play1 		= this.$refs.audio_play;
							this.sound_play1.muted 	= false;
							this.sound_play1.play();*/	
						}
					})
				}else{
						if (this.alert_sound) { // == 'alert'
							this.$Sounds.stop(this.alert_sound);							
							/*this.sound_play.stop();
						}else{
							this.sound_play1.stop();*/
						}
				}
					
				// }
			}, // render sound

			render_category(item, alert){							
				
				let list 	  = [],
					search 	  = '',
					sound 	  = false,
					popup 	  = false,
					time 	  = 10,
					color 	  = 'error',
					alert_mp3 = 'alert' ;

				if (item) {
					// console.log('exist info', item, alert)
					/*if (this.info_to_category && this.info_to_category.length > 0) {
						list = this.info_to_category;
					}else{
						list = this.default_category;
					}*/
							


					if (item.tag) {
						search = item.tag; 
						if (item.prediction) {
							search = item.prediction;
						} 
						if (item.tag == 'Access Granted') {
							color 			 = 'success';
							alert_mp3 		 = 'alert_success';  // alert_mp3
						}						 
							
						// if (list && list.length > 0) {
						if (alert) {
							const { timeoutAlert } 	= this.$Format.get_parameters();
							let arr_cat 			= alert;
									sound = arr_cat.isSound 	? true : false;
									popup = arr_cat.isPopup 	? true : false;
									color = arr_cat.color 		? arr_cat.color  	 : color;
									time  = arr_cat.timeout == -1 || timeoutAlert == -1  ? -1 : arr_cat.timeout? arr_cat.timeout : (timeoutAlert || 5);//10
									this.alert_sound = arr_cat.sound ? arr_cat.sound : alert_mp3;
									
							/*console.log('*****************\n  info category : popup :', popup,
										"\n is_snack ", this.is_snack, 
										'\n timer : ' + time, 
										'\n sound : ' + sound, this.is_soundd);*/
							

								if (popup) {
									if (this.is_snack){
										// this.modal_is_active 				= pop_up_active;
										this.snack_modal.active  			= true;
										this.snack_modal.color 				= 'dark';										
										this.snack_modal.time  				= time == -1 ? -1 : time  * 1000;	
									}else{
										this.dialog = popup;
									}
									if (time > 0 || time == -1) {
										this.render_colors(time, color);
									}
								}
								if (sound && this.is_soundd) {
									this.render_sound(true, {item, alert});
								}

							// }
							if (!popup) {

								this.actions('cancel_alert');
								
							}
						// } // check list
						}else{
							console.log("No found alert / tag");
							this.actions('cancel_alert');
							
						} // alert
					} // tag

				} // item
			}, // render category

			render_colors(timer, color){
				if (timer > 0) {
					// time to close
					let timeout_temp = setTimeout(() =>{						
						
						if(this.type == 'snack'){
							this.render_close();
						}else{
							this.dialog = false;
						}
					},timer  * 1000)
					this.timeout_alert = timeout_temp;

					// timer to close
					this.timer_color_close(timer, color);
				}else if(timer == -1){
					this.timer_color_close(5, color);
				}
			}, // render colors

			timer_color_close(timer, color){				
				this.timeout_alert_close 	= timer;
				let seg 					= timer;
				let sw_color 				= 0;
				let temp_timer = setInterval( () =>{
					if ((seg + 1) > this.timeout_alert_close) {						
						if ([0,2,4].includes(this.timeout_alert_close)) {
							this.show_color = color;
						}else {
							this.show_color = 'dark';
						}
					}						
					if(this.timeout_alert_close === 0 /*> (seg + 1)*/){
						clearInterval(this.timeout_alert_stop);
						this.show_color = 'dark';
					}
					this.timeout_alert_close--;
				}, 1000);
				this.timeout_alert_stop = temp_timer;
			}, // time color close

			draw_bbox(bbox){
				// if (bbox) {
					let items = [],						
						vm 	  = this,
						tag_1 = '';
					// console.log("bbox", bbox);
					if (this.info && this.info.contentt && this.info.contentt.images && this.info.contentt.images.length > 0) {
						items = this.info.contentt.images;						
						tag_1 = vm.info_head && vm.info_head.tag ? vm.info_head.tag : ''; 
					}

					this.$nextTick(()=>{       
						if (items && items.length > 0){

							// console.log("items bbox ************************************", items);
							items.forEach( function(arr_bbx, idx_bbx){
								 
								
								// console.log("arr_bbx", arr_bbx);

						        // let streaming         =   document.getElementById('stream' + );
						        // let context_streaming =   streaming.getContext('2d');

						         
								 
						       	// vm.$nextTick 
						       	const timer = setTimeout(()=>{
							        // container div 
							        let content           = document.getElementById('content_modal' + idx_bbx + vm.type + vm.ref_to_component);

							        // image background
							        let img               = document.getElementById('img_modal' + idx_bbx  + vm.type + vm.ref_to_component);

							        // canvas draw
							       	let roi  			  = document.getElementById('draw_modal' + idx_bbx  + vm.type + vm.ref_to_component);
							        let context_roi       = null;

							        // check snack
							        // console.log("**************** bbox check : ", content, img, roi);
							        if (!content && !img  && !roi){
							        	content           = document.getElementById('content_snack' + idx_bbx + vm.type + vm.ref_to_component);

								        // image background
								        img               = document.getElementById('img_snack' + idx_bbx  + vm.type + vm.ref_to_component);

								        // canvas draw
								       	roi  			  = document.getElementById('draw_snack' + idx_bbx  + vm.type + vm.ref_to_component);
							        	// console.log("**************** bbox check snack : ", content, img, roi);

							        }

							        if (roi && roi.getContext('2d')) {
							        	context_roi        = roi.getContext('2d');

							        	let less = 0;
							        	// content.style.height =  content.style.width;
							        	// console.log("context_ ", content.style.width ,content.getBoundingClientRect().height + 5, img.getBoundingClientRect().height)
 							       		// const time_tick = setTimeout(()=>{
							            roi.style.height = img.style.height = content.style.height = content.getBoundingClientRect().height + 'px'; /*(current_height)*/
							       		
							       		let current_width  = roi.width    = img.getBoundingClientRect().width,  
							            	current_height = roi.height   = img.getBoundingClientRect().height;
							            	// console.log("current_height ", roi.getBoundingClientRect().height,  img.style.height)

							             // roi.style.width   = current_width  + 'px';
										 // roi.style.height  = current_height + 'px';
							           /* if (!bbox) {
							        		roi.style.width = "100%";
							        		
							        		img.style.width = "100%";
							        		
							        		content.style.width = 100;
							        		
							        	}*/
							        	// roi.height 			= current_height;
							        	// roi.style.height 	=100 + 'px';
							        	// console.log("ROI ",/* current_width, current_height, roi.style.width, roi.style.height,*/ roi.height, img.style)

							            // console.log(current_height, current_width, "height && width bounding ***************** ", arr_bbx)
							            context_roi.clearRect(0, 0, current_width, current_height );

							            /*vm.draw.rois.push({ 
							            	roi, 
							            	context_roi, 
							            	current_width, 
							            	current_height
							            })*/
							            // let len_idx = vm.draw.rois.length - 1;  

							            if (arr_bbx && typeof arr_bbx == 'string') {
							            	try{
							            		arr_bbx = JSON.parse(arr_bbx)
							            		if (arr_bbx && typeof arr_bbx == 'string') {
							            			arr_bbx = JSON.parse(arr_bbx);
							            		}
							            	}catch(er){
							            		console.log("Not possible convert bbox to object ", er);
							            	}
							            }

							            if (arr_bbx && arr_bbx.bbox && arr_bbx.bbox.length > 0) {
							            	// console.log("BBOX : ***************** ", arr_bbx.bbox)
							            	arr_bbx.bbox.forEach( element => {
							            		if (element) {


							            			let color_set = '';
							            			let temp_tag  = element.tag || tag_1;
									                if (vm.draw_colors && vm.draw_colors.length > 0) {
									                  const find_color = vm.draw_colors.some( (tag_color => {
									                    if (tag_color.tag == temp_tag) {
									                      color_set = tag_color.color;
									                      return true
									                    }
									                  })) 
									                }
									                if(!color_set){
									            		let o    = Math.round, r = Math.random, s = 255;
										                let ca   = 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ',0.5)';
										                let num1 = o(r()*s)
										                let num2 = o(r()*s)
										                let num3 = o(r()*s)
									                	
									                	color_set	= 'rgba('+num1+','+num2+','+num3+',0.5)';

									                }

									                // color stroke / fill 

									                context_roi.strokeStyle = color_set;
									                // width line
													
									                context_roi.lineWidth   = vm.line_width || 2;
													
									                let b_box = {
									                	x : element.bbox && element.bbox.x ? element.bbox.x : element.x,
														y : element.bbox && element.bbox.y ? element.bbox.y : element.y,
														w : element.bbox && element.bbox.w ? element.bbox.w : element.w,
														h : element.bbox && element.bbox.h ? element.bbox.h : element.h,
													};

									                let fx = b_box.x *  parseInt(current_width) ;
									                let fy = b_box.y *  parseInt(current_height);
									                let w  = b_box.w *  parseInt(current_width);
									                let h  = b_box.h *  parseInt(current_height);

									                fx = Math.abs(fx)
	                								fy = Math.abs(fy)

									                //element.tag ? element.tag : '';
	                								
	                								// draw 
	                								// console.log("DRAWing ", temp_tag, fx, fy, w, h )
									                context_roi.strokeRect(fx, fy, w, h); // fill

									                
									                context_roi.font      = "12px Georgia";
									                context_roi.fillStyle = "white";//"rgba(96,96,96)"; // 0,0,0,1 
									                context_roi.fillText(temp_tag, fx + 20, fy + 10);//(element.bbox.x*factorx)+20, (element.bbox.y*factory)+20);
									                if (vm.type == 'alert') {

									              /*  const timer_redraw = setInterval(()=>{
										                roi.style.width   = roi.width  = context_roi.canvas.width  = current_width;
														roi.style.height  = roi.height = context_roi.canvas.height = current_height;
									                	
									                	// color stroke / fill 

										                context_roi.strokeStyle = color_set;
										                // width line
														
										                context_roi.lineWidth   = vm.line_width || 2;
										                context_roi.strokeRect(fx, fy, w, h); // fill

										                context_roi.font      = "12px Georgia";
										                context_roi.fillStyle = "white";//"rgba(96,96,96)"; // 0,0,0,1 
										                context_roi.fillText(temp_tag, fx + 20, fy + 10)
										                // console.log("redraw")
										                if (!vm.dialog) {
									                		clearInterval(timer_redraw);
									                		// console.log("cleare interval draw")
										                }
									                }, 1500) */
									                }
								              	}  
							            	}); // forEach
							            }else{
							            	console.log("BBOX Not found : ***************** "/*, arr_bbx.bbox*/);
							            }
							            // clearTimeout(time_tick);
							        // }, 100)
							        }else{
							        	console.warn("Context not compatible with 2D ",  idx_bbx);
							        }
							        clearTimeout(timer);
						       	}, 350) // 2
							}); // forEach
						} // items
					}); // next tick
				// } // item
			}, // draw bbox

			render_close_snack(){
				let clear 	= null; 		
				this.info 	= {
					img_full : this.$EXT + '/img/no_img_found.png',
				};	
				this.$emit('close',clear);
				// this.$emit('check_modal',false);
				
				if (this.time_out) {
					clearTimeout(this.time_out);
				}
				if (this.stop_time) {
					clearInterval(this.stop_time);
				}				
			}, // render close snack

			get_videoss(date, deviceId){
					
					
				if(date){
					
					// let time = this.$moment.duration("30", "seconds");
					// let subs = dt.subtract(time);
					 // this.$moment(date).format("YYYY/MM/DD_HH-mm-ss")
					
					
					let dates = this.$Format.format_date_to_dates_seg(date, 300000, 'subtract');
					console.log("dates : ", dates);
					let search = {
						timeZone : this.$timezone, 
						start 	 : dates[0],
						end 	 : dates[1],
						deviceId
					}

					const api = this.$URL + "/api/v1/records/find/video";
					this.$axios.post(api, search).then( res => {
						if (res && res.data && res.data.rows && res.data.rows.length > 0) {

							let items 	 = res.data.rows, 
								new_list = [];
							for (let i = 0; i < items.length; i++) {
								if(items[i].urlpath){									
									new_list.push(this.$URL + items[i].urlpath);								
								}
							}						

							if (new_list.length > 0) {
								// this.col_md=4;
								this.show_video   			= true;						
								this.list_videos  			= new_list;		
								this.info.cont_video_map 	= true;	// videoss
								if (!this.list_show.includes("content_video_location")) {
									this.list_show.push("content_video_location");
								}
								this.render_cols();
								// this.render_cols('content3');
								// this.render_cols('videos');
								this.draw_bbox(true);


							}
						}
					}).catch(er => {
						console.log("er get video : ", er);					
					}) 
				}

			}, // get videos

			get_video(item){
				if (item) {
					let date 	= item.date_utc; // date_utc
					let search 	= [];
					let date1 	= (date.split(':')[0])+':' + (date.split(':')[1]) + ':';
					let date2 	= parseInt(date.split(':')[2]) - 20 + '.000Z';
					let date3 	= date1 + date2;
					/*let date1=date.split(' ')[0]+' '+date.split(' ')[1];
					let date2=parseInt(date.split(' ')[2])-20;
					let date3=date1+' '+date2;*/
					
					// console.log(date3, 'time', date)
					
					let ID_device 	= null;
						// list 		= this.list_modal,
						// host_search = null;

					
						/*if (item.host){
							host_search = item.host;
						}*/

					
					/*
					list.forEach( function (val, i){							
						if (val && val.host.name == host_search && val.host.device) {
							ID_device = val.host.device[0].id;
						}
					})*/
					if (item.id_device) {
						ID_device = item.id_device;
					}
					search = {
						dateRange : [date3 ,date],
						name 	  : ID_device,
					};
					// console.log('search video nvr', search)

					const api = this.$URL + '/api/v1/nvr/reports/';		
					this.$axios.post(api, search).then( res => {
						console.log(res, 'res videos ')
						let items 	 = res.data.rows, 
							new_list = [];
						for (let i = 0; i < items.length; i++) {
							if(items[i].urlpath){
								let url = this.$URL + items[i].urlpath;
								new_list.push(url);								
							}
						}						

						if (new_list.length > 0) {
							// this.col_md=4;
							this.show_video = true;						
						}
						this.list_videos = new_list;		
					}).catch(er => {
						console.log("er get video : ", er);					
					}) 
				}else{
					console.log("Not found item for search videos ", item);
				}
			}, // get video

			trained(){
				const api 	= this.$URL + "/api/v1/face/train";
				let ids     = [];
				let uuid 	= "";
				let name 	= "";
				if(this.info_selections?.contentt1 && this.info_selections?.contentt1?.length === 0){
					this.$EventBus.$emit("notifications_modal",{ type    : "warning", message : this.$ml.get("face_selection_required"),});
					this.isRequiredSelectionFace=true;
					return
				}else{
					this.isRequiredSelectionFace=false;
				}
				if (this.info && this.info.contentt1) {
					if (this.info.contentt1.images && this.info.contentt1.images.length > 0) {

						const filters = this.info.contentt1.images.filter((x,idx) => { 
							// console.log(x, idx)
							if (x && this.info_selections.contentt1.includes(idx)){
								ids.push(x.id)
							}
						})
					}
					// console.log("ids ", ids)
				}
				if (this.info_selections && this.info_selections.trained && this.info_selections.trained.userId) { // faceUUID
					uuid = this.info_selections.trained.userId;// faceUUID
					name = this.info_selections.trained.userName;
				}
				let info_up = {
					deviceId : this.info_to_component.deviceId,
					name 	 : this.info_selections.name || name,
					faceUUID : uuid,
					ids ,
				};
				
				this.loadings.contentt1 = true;

				this.$axios.post(api, info_up).then( res => {
					this.loadings.contentt1 = false;
					this.disableds.to_train = true;
					this.$EventBus.$emit("notifications_modal",{
						type    : "success",
						message : "Training faces"
					});
					if (res && res.data) {
						if (uuid) {							
							if (this.info_selections && this.info_selections.trained && res.data.face_trained) {
								this.info_selections.trained.face_trained =  this.info_selections.trained.face_trained.concat(res.data.face_trained);
								this.$Format.update_to_lists("list_traineds", this.info_selections.trained);								
							}							
						}else{
							let temp = res.data;
							if (temp.createdAt) {
								temp.date_at = this.$Format.format_date(temp.createdAt, "createdAt")
							}
							try {

								if (temp && temp.face_trained && temp.face_trained.length > 0 &&  temp.face_trained[0].face_cropping && temp.face_trained[0].face_cropping.url) {
				  					temp.url_face 		= this.$URL + temp.face_trained.face_trained[0].face_cropping.url;	  					
				  					temp.number_trained = temp.face_trained.face_trained.length;
				  					
				  				}else{
				  					temp.url_face 		= this.$EXT + "/img/no_img_found.png";	  					
				  					temp.number_trained = 0;
				  				}
							}catch(err){
								console.warn("Error add train to traineds", err)
							}
							this.$Format.add_to_lists("list_traineds", { ...temp});
						}
					}

				}).catch(er => {
					console.warn("Error trained " , er);
					this.loadings.contentt1 = false;
					this.$EventBus.$emit("notifications_modal",{
						type    : "error",
						message : "Training faces"
					})
				})
			}, // trained
						

			zoom(e){
				// console.log("ZOOM ", e)
			  	// let zoomer = e.currentTarget;

			  	// let offsetX, offsetY, x, y;
				// e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
				// e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
				// x = offsetX / zoomer.offsetWidth  * 100;
				// y = offsetY / zoomer.offsetHeight * 100;
				// zoomer.style.backgroundPosition = x + '% ' + y + '%';
				 const figure = event.currentTarget;
			    const img = figure.querySelector("img");
			    
			    const { offsetX, offsetY } = event;
			    const { offsetWidth, offsetHeight } = figure;

			    const x = (offsetX / offsetWidth) * 100;
			    const y = (offsetY / offsetHeight) * 100;

			    img.style.transform = `scale(2)`;
			    img.style.transformOrigin = `${x}% ${y}%`;
			}, // zoom

			resetZoom(event) {
		      // const img = event?.currentTarget;
		      // if (img) img.style.transform = 'scale(1)';
				const img = event.currentTarget.querySelector("img");
			    img.style.transform = "scale(1)";
			    img.style.transformOrigin = "center center";
		    },
		    openImage(image) {
		      if (image) {
		        window.open(this.$Helper.check_img(image, this.$URL), '_blank');
		      }
		    }

		}, // methods

		mounted(){	
			/*if (!this.sound_play) {		
				this.$nextTick(()=>{
					let sound = this.$refs.audio_play;//	
					this.sound_play = sound;
					// console.log(this.sound_play)	
					// this.sound_play.muted 	= false;
					// sound.play();	
											

				})				
			}	*/		
			

		}, // mounted

		

	}; // export default